// DS: TODO
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const EditorLayoutGrid: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
      >
        <path d="M21 3C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21ZM11 13H4V19H11V13ZM20 13H13V19H20V13ZM11 5H4V11H11V5ZM20 5H13V11H20V5Z"></path>
      </svg>
    </IconWrap>
  );
};
EditorLayoutGrid.displayName = 'EditorLayoutGrid';

export default EditorLayoutGrid;
